import React from 'react';

export default function Logo({ variant = 'dark' }) {
  const stroke = variant === 'dark' ? '#0F1B2D' : '#F6F1E7';
  const gold = '#C79A5A';
  return (
    <div className="auro-logo">
      <svg width="34" height="34" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill={stroke} />
        <g fill={gold}>
          <rect x="14" y="22" width="10" height="30" rx="1.5" />
          <rect x="27" y="14" width="10" height="38" rx="1.5" />
          <rect x="40" y="26" width="10" height="26" rx="1.5" />
        </g>
      </svg>
      <span className="auro-logo__wordmark">
        Auronixio<span className="auro-logo__dot">.</span>
      </span>
    </div>
  );
}
